<template>
</template>

<script>
import {Bus} from "@/main";

export default {
    name: "setting",
    props: {
        price: {
            default: 0
        },
        expire: {
            default: 0,
        },

    },
    data() {
        return {
            setting: [],
            settingValues: [],
            translates: [],

        }
    },
    methods: {
        getSettings() {
            $.ajax({
                url: `${url}/setting`,
                type:'GET',
                fn: this.getSettings,
                headers: {
                    'ACCEPT': 'application/json',
                    Authorization: Token
                },
                success: (data) => {
                    this.setting = data.data
                }
            })
        },
    },
    watch:{
        setting:{
            handler:function (value) {
                Bus.$emit('sendSetting',value)
            },
            deep:true
        }
    },
    mounted() {
        this.getSettings();
    }
}
</script>

<style scoped>

</style>